<template>
	<div id="message" v-if="type">
		<top :topIndex="3"></top>
		<div class="mian" :style="{ height: mianH + 'px' }">
			<div class="apart_list">
				<left :leftIndex="3"></left>
				<ApartInit v-if="type === 'init'" :user="user" @toAdd="addApart" @openVip="openVip"/>
				<ApartList @toAdd="addApart" v-else-if="type === 'list'"></ApartList>
				<ApartAdd v-else-if="type === 'add'" @goBack="(e) => { type = e || 'list' }" />
			</div>

		</div>
	</div>
</template>
<script>
import api from '@/api/api';
import apart from '@/api/apart';
import top from '../components/top.vue' //顶部
import left from '../components/left.vue' //左侧
import ApartList from '../components/apart/list.vue' //左侧
import ApartInit from '@/components/apart/init.vue' //没有数据初始化页面
import ApartAdd from '@/components/apart/add.vue' //去拆書添加
import { EventBus } from '@/utils/eventBus';
export default {
	components: {
		top, left, ApartList, ApartInit, ApartAdd
	},
	data() {
		return {
			mianH: 0,//主题区域宽度
			type: 'init',//狀態區分功能块,list add init 三种类型
			user: {},
		}
	},
	mounted() {
		this.calculateMianHeight();
		window.addEventListener('resize', this.calculateMianHeight);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.calculateMianHeight);
	},
	methods: {
		calculateMianHeight() {
			this.mianH = window.innerHeight - 63;
		},
		addApart(e) {
			this.type = e
		},
		openVip() {
            EventBus.$emit('openVip')
        },
		init() {
			api.getUserinfo().then((result) => {
				if (result.code === 200) {
					if (Object.keys(result.data).length > 0) {
						let user = result.data
						this.user = user
						apart.getApartList().then(res => {
							if (res.code === 200) {
								if (!user.vip && !res.total) {
									this.type = 'init'
								} else if (user.vip && !res.total) {
									this.type = 'init'
								} else if (user.vip && res.total) {
									this.type = 'list'
								}
							}

						})
					}
				}
			})
		}
	},
	created() {
		this.init();
	},
}
</script>

<style>
#message {
	width: 100%;
	height: 100vh;
	display: flex;
	flex-flow: column;
}

.apart_list {
	display: flex;
	flex: 1;
}
</style>